<div class="add-employee-dialog">
  <div class="dialog-header">
    <h2>{{ isEdit ? 'Edit Employee' : 'Add Employee' }}</h2>
    <mat-icon class="close-icon" (click)="onCancel()">close</mat-icon>
  </div>

  <form [formGroup]="employeeForm" (ngSubmit)="onSubmit()" class="employee-form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>First Name *</mat-label>
        <input matInput formControlName="firstName" placeholder="First name">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Last Name *</mat-label>
        <input matInput formControlName="lastName" placeholder="Last name">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Birth Date</mat-label>
        <input matInput formControlName="birthDate" placeholder="YYYY-MM-DD" type="date">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Birth Year</mat-label>
        <input matInput formControlName="birthYear" type="number" placeholder="e.g. 1990">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>JMBG</mat-label>
        <input matInput formControlName="jmbg" placeholder="Personal ID number">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Municipality Code</mat-label>
        <input matInput formControlName="municipalityCode" placeholder="Municipality code">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Address</mat-label>
        <input matInput formControlName="address" placeholder="Street address">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Residence</mat-label>
        <input matInput formControlName="residence" placeholder="City / Place of residence">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Employment Start Date</mat-label>
        <input matInput formControlName="startDate" placeholder="YYYY-MM-DD" type="date">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Employment End Date</mat-label>
        <input matInput formControlName="endDate" placeholder="YYYY-MM-DD" type="date">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Tax Card</mat-label>
        <input matInput formControlName="taxCard" placeholder="Tax card number">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Gross Salary (Bruto I)</mat-label>
        <input matInput formControlName="grossSalary" type="number" placeholder="0.00">
        <span matSuffix>&nbsp;KM</span>
      </mat-form-field>
    </div>

    <div class="dialog-actions">
      <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
      <button
        class="primary-button"
        type="submit"
        [disabled]="employeeForm.invalid"
      >
        {{ isEdit ? 'Update' : 'Add' }}
      </button>
    </div>
  </form>
</div>
